import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {ScheduledReportsTable} from '../components/ScheduledReportsTable';
import NoAccess from '../noAccess';
import {isSysopOrSysadmin, hasSectionAccess} from '../shared/authFunctions';
import FuseTheme from '../global/theme';
import Avatar from 'material-ui/Avatar';
import RaisedButton from 'material-ui/RaisedButton';
import {Card, CardText} from 'material-ui/Card';
import ContentUpdate from 'material-ui/svg-icons/action/update';
import Icon from 'material-ui/svg-icons/action/schedule';

export const fuseScheduledReportsIcon = Icon;

const styles = {
    error: {fontSize: 16, color: FuseTheme.palette.errorColor},
};

/**
 * Landing Page with links to schedule Reports and display existing Scheduled Reports
 *
 */
export class ScheduledReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: null
        };
    }

    render() {
        const {
            errorMessage
        } = this.state;

        if (!isSysopOrSysadmin()) {
            if (!hasSectionAccess('schedule_reports')) return <NoAccess/>;
        }

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Scheduled Reports</span>;

        return (
            <div className="lists-container">
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <span className="list-description hide-print">
                            <p>Schedule a new Report by clicking <strong>Schedule Report</strong>.</p>
                            <br/>
                            <RaisedButton
                                primary
                                label="Schedule A Report"
                                icon={<ContentUpdate/>}
                                containerElement={<Link to="/ScheduleReport"/>}
                            />
                            <br/><br/><br/>
                            View the list of scheduled Reports below.
                        </span>

                        {/* Error and Messaging */}
                        {errorMessage &&
                            <div style={styles.error}>
                                <p>{errorMessage}</p>
                            </div>
                        }

                        {/* Existing Scheduled Reports */}
                        <div>
                            <ScheduledReportsTable/>
                        </div>
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/views/ScheduledReports.js